import React, { useEffect } from 'react';
import 'carbon-components/css/carbon-components.min.css';
import { useField } from '@formiz/core'
import { TextInput, TextArea, Select, SelectItem, Checkbox, RadioButton, FileUploaderButton, FormGroup, SelectableTile, TileGroup, RadioTile, FormLabel, DatePicker, DatePickerInput } from "carbon-components-react";
import { injectIntl, FormattedMessage } from 'react-intl';
// @ts-ignore
import MultiSelect from "react-multi-select-component"
import { COUNTRY_CODES, COUNTRY_CODES_AR } from '../data/CountryCodes';

/* @ts-ignore */
export const InputField = (props) => {
  const { errorMessage, id, isValid, isSubmitted, setValue, value } = useField(props)
  const { label, disabled } = props
  const [isTouched, setIsTouched] = React.useState(false)
  const showError = !isValid && (isTouched || isSubmitted)

  return (
    <div className={`form-group ${(showError) ? 'is-error' : ''}`}>
      <TextInput
          id={id}
          type="text"
          value={value ?? ''}
          invalid={showError}
          invalidText={errorMessage}
          className="bx--text-input minwidth-0 no-mgn-btm"
          labelText={label}
          onChange={e => setValue(e.target.value)}
          onBlur={() => setIsTouched(true)}
          placeholder={label}
          disabled={disabled}
          >
        </TextInput>
    </div>
  )
}

/* @ts-ignore */
export const CheckboxField = (props) => {
  const { isValid, isSubmitted, setValue, value } = useField(props)
  const { label, onChange, name, id } = props
  const [isTouched, setIsTouched] = React.useState(false)
  const showError = !isValid && (isTouched || isSubmitted)

  const handleChange = (checked, checkboxId, event) => {
    setValue(checked ? true : undefined)
    setIsTouched(true)
    // Call custom onChange if provided
    if (onChange) {
      onChange(checked, checkboxId, event)
    }
  }

  return (
    <div className={`form-group ${(showError) ? 'is-error' : ''}`}>
      <Checkbox
          id={id || name}
          labelText={label}
          checked={value === true || value === 'Yes'}
          onChange={handleChange}
          onBlur={(e) => setIsTouched(true)}
          title={name}
        >
      </Checkbox>
    </div>
  )
}

/* @ts-ignore */
export const TextAreaField = (props) => {
  const { errorMessage, id, isValid, isSubmitted, setValue, value } = useField(props)
  const { label, placeholder } = props
  const [isTouched, setIsTouched] = React.useState(false)
  const showError = !isValid && (isTouched || isSubmitted)

  return (
    <div className={`form-group ${(showError) ? 'is-error' : ''}`}>
      <TextArea
          id={id}
          rows={4}
          value={value ?? ''}
          placeholder={placeholder ?? ''}
          invalid={showError}
          invalidText={errorMessage}
          className="bx--text-input minwidth-0 no-mgn-btm"
          labelText={label}
          onChange={e => setValue(e.target.value)}
          onBlur={(e) => setIsTouched(true)}
          >
        </TextArea>
    </div>
  )
}

/* @ts-ignore */
const SelectField = (props) => {
  /* eslint-disable-next-line */
  const { errorMessage, id, isValid, isSubmitted, setValue, value } = useField(props)
  const { label, options, defaultSelected, disabled, className, placeholder } = props
  const [isTouched, setIsTouched] = React.useState(false)
  const [selectedValue, setSelectedValue] = React.useState(null)
  const showError = !isValid && (isTouched || isSubmitted)

  let select_options = []
  for (let [key, values] of Object.entries(options)) {
    select_options.push(
      <SelectItem
        disabled={false}
        hidden={false}
        // @ts-ignore
        text={values}
        key={key}
        value={key}
      />
    )
  }

  useEffect(() => {
    // @ts-ignore
    selectedValue && setValue(options[selectedValue])
  });

  // @ts-ignore
  const setSelectValue = (e) => {
    setValue(e)
    setSelectedValue(e)
  }

  return (
    <div className={`form-group ${(showError) ? 'is-error' : ''}`}>
        <Select
          defaultValue={defaultSelected ? defaultSelected : 'placeholder-item'}
          disabled={disabled}
          id={id}
          inline={false}
          invalid={showError}
          invalidText={errorMessage}
          labelText={label || null}
          className={className || null}
          light={false}
          // @ts-ignore
          onChange={e => setSelectValue(e.target.value)}
          onBlur={() => setIsTouched(true)}
        >
          <SelectItem
            disabled
            hidden
            text={ props.intl.formatMessage({ id: "select.default" }) }
            value="placeholder-item"
          />
          {
            select_options
          }
        </Select>
    </div>
  )
}

/* @ts-ignore */
export const RadioField = (props) => {
  const { errorMessage, id, isValid, isSubmitted, setValue, value } = useField(props)
  const { label, options, name, checked } = props
  const [isTouched] = React.useState(false)
  const [selectedValue, setSelectedValue] = React.useState(null)
  const showError = !isValid && (isTouched || isSubmitted)

  let select_options = []
  var index = 0;
  for (let [key, values] of Object.entries(options)) {
    var isChecked = index === 0 && true
    // @ts-ignore
    // index === 0 && setDefaultValue(values)
    select_options.push(
      <RadioButton
        key={key}
        id={key}
        name={name}
        labelText={checked.formatMessage({ id: values })}
        value={key}
        defaultChecked={isChecked}
        // @ts-ignore
        onClick={ e => setSelectValue( key ) }
      />
    )
    index++;
  }

  useEffect(() => {
    selectedValue ? setValue(checked.formatMessage({ id: "field." + selectedValue })) : setValue(checked.formatMessage({ id: "field." + Object.entries(options)[0][0] }))
  });

  // @ts-ignore
  const setSelectValue = (e) => {
    setValue(e)
    setSelectedValue(e)
  }

  return (
    <div className={`form-group ${(showError) ? 'is-error' : ''}`}>
      <FormGroup
          invalid={false}
          legendText={label}
          message={false}
          messageText=""
        >
        <div className="bx--radio-button-group bx--radio-button-group--label-right">
          {
              select_options
          }
        </div>
      </FormGroup>
      {showError && (
        <div id={`${id}-error`} className="form-feedback">
          { errorMessage }
        </div>
      )}
    </div>
  )
}

/**
 * Convert file to base64 string
 */
const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      // Remove data URL prefix (e.g., "data:image/png;base64,")
      const base64String = (reader.result as string).split(',')[1];
      resolve(base64String);
    };
    reader.onerror = (error) => reject(error);
  });
};

/**
 * Get folder path based on form type for OneDrive
 */
const getOneDriveFolderPath = (formType: string): string => {
  const folderMap: { [key: string]: string } = {
    qatarization: 'Forms/Qatarization',
    balagh: 'Forms/Balagh',
    interview: 'Forms/Interview',
    mediainquiries: 'Forms/MediaInquiries',
    multimedia: 'Forms/Multimedia',
    mailinglist: 'Forms/MailingList',
    photography: 'Forms/Photography',
    visit: 'Forms/Visit',
    mediatours: 'Forms/MediaTours',
  };

  return folderMap[formType?.toLowerCase()] || 'Forms';
};

/* @ts-ignore */
export const FileUploaderField = (props) => {
  const { label, acceptFileType, name, form } = props
  const { errorMessage, id, isValid, isSubmitted, setValue, value } = useField(props)
  const [isFileInvalid, setIsFileInvalid] = React.useState(false)
  const [originalFileName, setOriginalFileName] = React.useState(null)
  const [isUploading, setIsUploading] = React.useState(false)
  const [uploadError, setUploadError] = React.useState<string | null>(null)
  const showError = !isValid && isSubmitted

  const clearFile = () => {
    setValue(undefined)
    setIsFileInvalid(false)
    setUploadError(null)
  }

  const resetFile = () => {
    setValue(undefined)
    setIsFileInvalid(true)
    setUploadError(null)
  }
  
  /* @ts-ignore */
  const handleFileUpload = async (e) => {
    // @ts-ignore
    var fileInputElement = document.getElementById("id1") as HTMLInputElement;
    
    if (!fileInputElement || !fileInputElement.files || !fileInputElement.files[0]) {
      return;
    }

    const file = fileInputElement.files[0];
    
    // @ts-ignore
    var file_name = file.name.substr(0, file.name.lastIndexOf("."))
    // @ts-ignore
    var file_ext = file.name.split('.').pop();

    // Sanitize filename to remove dangerous characters for OneDrive connector
    // Remove or replace characters that are problematic in file paths: ? / \ : * " < > |
    const sanitizeFileName = (name: string): string => {
      return name
        .replace(/[?/\\:*"<>|]/g, '_') // Replace dangerous characters with underscore
        .replace(/\s+/g, '_') // Replace spaces with underscore
        .replace(/_{2,}/g, '_') // Replace multiple underscores with single underscore
        .replace(/^_+|_+$/g, ''); // Remove leading/trailing underscores
    };

    var sanitized_file_name = sanitizeFileName(file_name);
    var new_filename = `${sanitized_file_name}-${Date.now()}.${file_ext}`

    /* @ts-ignore */
    var FileSize = file.size / 1024 / 1024; // in MB
    if (FileSize > 10) {
      /* @ts-ignore */
        resetFile()
        setIsFileInvalid(true)
        setUploadError('File size exceeds 10MB limit')
        return false;
    }

    setIsUploading(true)
    setIsFileInvalid(false)
    setUploadError(null)
    // @ts-ignore
    setOriginalFileName(file.name)

    try {
      // Convert file to base64
      const base64Content = await fileToBase64(file);
      
      // Store both filename and base64 content as JSON string
      // The Logic App expects:
      // - base64 content in 'uploaded_file' field
      // - filename in 'file_name' field (separate field)
      const fileData = {
        filename: new_filename,
        base64: base64Content
      };
      
      // Store as JSON string - will be parsed in Wizard.tsx to extract both values
      setValue(JSON.stringify(fileData))
      setIsFileInvalid(false)
      setUploadError(null)
      console.log("File converted to base64 successfully!")
    } catch (error) {
      console.error("Error converting file to base64:", error)
      setValue(undefined)
      setIsFileInvalid(true)
      setUploadError(error instanceof Error ? error.message : 'Failed to process file. Please try again.')
    } finally {
      setIsUploading(false)
    }
  }
  
  return (
    <div id="file__container" className={`bx--file__container ${isFileInvalid ? "invalidFile" : null}`}>
      <FormGroup
        legendText={label}
        className={showError ? 'file_error' : ''}
        >
          <FileUploaderButton
            labelText={
              isUploading 
                ? 'Uploading...' 
                : value 
                  ? originalFileName 
                  : <FormattedMessage id={`upload_placeholder`} />
            }
            accept={acceptFileType}
            /* @ts-ignore */
            name={name}
            buttonKind={'tertiary'}
            /* @ts-ignore */
            onChange={(e) => handleFileUpload(e)} 
            /* @ts-ignore */
            onDelete={e => clearFile()}
            multiple={false}
            listFiles={true}
            size="field"
            fileInvalid={isFileInvalid}
            disabled={isUploading}
      />
      {value &&
        <span className="bx--file__state-container"><button onClick={() => { clearFile() }} aria-label="Clear file" className="bx--file-close" type="button" tabIndex={0}><svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="16" height="16" viewBox="0 0 32 32" aria-hidden="true"><path d="M24 9.4L22.6 8 16 14.6 9.4 8 8 9.4 14.6 16 8 22.6 9.4 24 16 17.4 22.6 24 24 22.6 17.4 16 24 9.4z"></path></svg></button></span>
      }
      {isFileInvalid && 
        <>
          <div id={'file_size'} className="bx--form-requirement">
            {uploadError || <FormattedMessage id={`file_size_limit_exceeded`} />}
          </div>
        </>
      }
      {showError && (
        <div id={`${id}-error`} className="bx--form-requirement">
          { errorMessage }
        </div>
      )}
      </FormGroup>
    </div>
  )
}

/* @ts-ignore */
export const TileField = (props) => {
  const { errorMessage, id, isValid, isSubmitted, setValue, value } = useField(props)
  const { label, disabled, title, className, onChange, group, hideError } = props
  const [isTouched, setIsTouched] = React.useState(false)
  const showError = !isValid && (isTouched || isSubmitted)
  const inputRef = React.useRef<HTMLInputElement>(null)
  const isSelected = value === label

  const handleChange = () => {
    const nextSelected = !isSelected

    if (inputRef.current) {
      inputRef.current.checked = nextSelected
    }

    setValue(nextSelected ? label : null)
    setIsTouched(true)
    if (onChange) {
      onChange(nextSelected)
    }
  }

  return (
    <div className="tiles">
        <FormLabel> { title } </FormLabel>
        <input
          ref={inputRef}
          type="checkbox"
          className="bx--tile-input"
          name={group}
          value={label}
          checked={isSelected}
          readOnly
          tabIndex={-1}
          aria-hidden="true"
        />
        <SelectableTile
          id={id}
          light={false}
          // @ts-ignore
          name={group}
          value={label}
          onChange={handleChange}
          selected={isSelected}
          tabIndex={0}
          title={title || "Tile selection"}
          className={className}
          disabled={disabled}
        >
          { label }
      </SelectableTile>
      {showError && !hideError && (
        <div id={`${id}-error`} className="bx--form-requirement tile-error-message">
          { errorMessage }
        </div>
      )}
    </div>
    
  )
}

/* @ts-ignore */
export const RadioTileField = (props) => {
  const { errorMessage, id, isValid, isSubmitted, setValue, value } = useField(props)
  const { label, options, name, checked } = props
  const [isTouched] = React.useState(false)
  const [selectedValue, setSelectedValue] = React.useState(null)
  const showError = !isValid && (isTouched || isSubmitted)

  let select_options = []
  var index = 0;
  for (let [key, values] of Object.entries(options)) {
    var isChecked = index === 0 && true
    // @ts-ignore
    // index === 0 && setDefaultValue(values)
    select_options.push(
      <RadioTile
        key={key}
        id={key}
        name={name}
        value={key}
        defaultChecked={isChecked}
        // @ts-ignore
        onClick={ e => setSelectValue( key ) }
        className={`radio_tile ${index == Object.keys(options).length - 1 && 'last'} ${index === 0 && 'first'}`}
      >
        { checked.formatMessage({ id: values }) }
      </RadioTile>
    )
    index++;
  }

  useEffect(() => {
    selectedValue ? setValue(checked.formatMessage({ id: "field." + selectedValue })) : setValue(checked.formatMessage({ id: "field." + Object.entries(options)[0][0] }))
  });

  // @ts-ignore
  const setSelectValue = (e) => {
    setValue(e)
    setSelectedValue(e)
  }

  return (
    <div className={`form-group ${(showError) ? 'is-error' : ''}`}>
      <TileGroup
          name={name}
          legend={label}
          defaultSelected={Object.entries(options)[0][0]}
          className="bx--tile-group"
        >
        { select_options }
      </TileGroup>
      {showError && (
        <div id={`${id}-error`} className="form-feedback">
          { errorMessage }
        </div>
      )}
    </div>
  )
}

/* @ts-ignore */
export const DatePickerField = (props) => {
  const { errorMessage, id, isValid, isSubmitted, setValue, value } = useField(props)
  const { label, disabled, className, required, maxDate, currLang } = props
  const [isTouched, setIsTouched] = React.useState(false)
  const [language, setLanguage] = React.useState(currLang)
  const showError = !isValid && (isTouched || isSubmitted)

  useEffect(() => {
    value && setValue(value)
    // @ts-ignore
    setLanguage('"' + currLang + '"')
  });

  // @ts-ignore
  const setDate = (e) => {
    var d = new Date(e);
    var dt_month = d.getMonth() + 1;
    var dt_day = d.getDate();
    var dt_year = d.getFullYear();
    var dt_date = dt_month + '/' + dt_day + '/' + dt_year;

    setValue(dt_date)
  }

  return (
    <div className={`form-group ${(showError) ? 'is-error' : ''}`}>
      <DatePicker
        dateFormat="m/d/Y"
        datePickerType="single"
        id="date-picker"
        className={className}
        light={false}
        // @ts-ignore
        locale={language}
        value={value}
        // @ts-ignore
        onChange={e => setDate(e)}
        onClose={function noRefCheck(){}}
        short={false}
        maxDate={maxDate}
      >
        <DatePickerInput
          // @ts-ignore
          className={className}
          disabled={false}
          iconDescription="Icon description"
          id={id}
          invalid={required ? typeof value == "string" && value.indexOf('/') > -1 ? false && setValue(null) : isTouched || isSubmitted && true : false}
          // @ts-ignore
          invalidText={<FormattedMessage id={`field.required`} />}
          labelText={label}
          openCalendar={function noRefCheck(){}}
          pattern="d{1,2}/d{4}"
          placeholder="mm/dd/yyyy"
          size={undefined}
          type="text"
          value={value}
        />
      </DatePicker>
    </div>
  )
}

/* @ts-ignore */
export const MultiSelectField = (props) => {
  /* eslint-disable-next-line */
  const { errorMessage, id, isValid, isSubmitted, setValue, value } = useField(props)
  const { label, options, searchPlaceholder } = props
  const [isTouched, setIsTouched] = React.useState(false)
  const showError = !isValid && (isTouched || isSubmitted)
  const [selected, setSelected] = React.useState([]);
  const [selectedValue, setSelectedValue] = React.useState(null)
  const [defaultText, setDefaultText] = React.useState(null);

  useEffect(() => {
    // @ts-ignore
    var items = []
    setDefaultText(label)
    // @ts-ignore
    selectedValue && setValue(options[selectedValue])
    // @ts-ignore
    // selected && console.log(selected)

    // @ts-ignore
    let yFilter = selected.map(itemY => { return itemY.value; });
    // @ts-ignore
    let filteredX = options.filter(itemX => yFilter.includes(itemX.value));

    // @ts-ignore
    filteredX.forEach(item =>  {
      // @ts-ignore
      items.push(item.label)
    })
    // @ts-ignore
    setValue(items.join(", "))
  });

  // @ts-ignore
  const customValueRenderer = (selected, _options) => {
    return selected.length
    // @ts-ignore
      ? selected.length + " " + defaultText
      : defaultText;
  };

  // @ts-ignore
  const setSelectValue = (e) => {
    setSelected(e)
     // @ts-ignore
     var items = []
     // @ts-ignore
     var keys = []
     // @ts-ignore
     e.forEach(item =>  {
       // @ts-ignore
       items.push(item.label)
       // @ts-ignore
       keys.push(item.value)
     })
     // @ts-ignore
     setValue(items.join(", "))
     // @ts-ignore
     setSelectedValue(keys)
  }

  const overrideStrings = {
    "search": searchPlaceholder
  }

  return (
    <div className={`form-group ${(showError) ? 'is-error' : ''}`}>
      <FormGroup
        legendText={label}>
        <MultiSelect
        options={options}
        value={selected}
        // @ts-ignore
        onChange={e => setSelectValue(e)}
        labelledBy={"Select"}
        hasSelectAll={false}
        // @ts-ignore
        valueRenderer={customValueRenderer}
        // @ts-ignore
        overrideStrings={overrideStrings}
      />
      {showError && (
        <div id={`${id}-error`} className="bx--form-requirement">
          { errorMessage }
        </div>
      )}
      </FormGroup>
    </div>
  )
}

/* @ts-ignore */
export const PhoneNumberField = (props) => {
  const { errorMessage, id, isValid, isSubmitted, setValue, value } = useField(props)
  const { label, required, validations, currLang } = props
  const [isTouched, setIsTouched] = React.useState(false)
  const [countryCode, setCountryCode] = React.useState('+974')
  const [mobileNumber, setMobileNumber] = React.useState('')
  const showError = !isValid && (isTouched || isSubmitted)

  useEffect(() => {
    // Parse existing value if it contains country code
    if (value && typeof value === 'string') {
      const match = value.match(/^(\+\d{1,4})(.*)$/)
      if (match) {
        setCountryCode(match[1])
        setMobileNumber(match[2])
      } else {
        setMobileNumber(value)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    // Update combined value when country code or mobile number changes
    if (mobileNumber) {
      setValue(`${countryCode}${mobileNumber}`)
    } else {
      setValue(undefined)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countryCode, mobileNumber])

  const handleCountryCodeChange = (e) => {
    setCountryCode(e.target.value)
  }

  const handleMobileChange = (e) => {
    setMobileNumber(e.target.value)
    setIsTouched(true)
  }

  const countryCodeOptions = currLang === "ar" ? COUNTRY_CODES_AR : COUNTRY_CODES

  return (
    <div className={`form-group ${(showError) ? 'is-error' : ''}`}>
      <FormLabel>{label}</FormLabel>
      <div className="phone-number-wrapper">
        <div className="country-code-select">
          <Select
            id={`${id}_country_code`}
            value={countryCode}
            onChange={handleCountryCodeChange}
            invalid={false}
            labelText=""
            light={false}
          >
            {countryCodeOptions.map((option) => (
              <SelectItem
                key={option.value}
                value={option.value}
                text={option.label}
              />
            ))}
          </Select>
        </div>
        <div className="mobile-input">
          <TextInput
            id={id}
            type="text"
            value={mobileNumber}
            invalid={showError}
            invalidText={errorMessage}
            className="bx--text-input minwidth-0 no-mgn-btm"
            labelText=""
            onChange={handleMobileChange}
            onBlur={() => setIsTouched(true)}
            placeholder={label}
          />
        </div>
      </div>
    </div>
  )
}

export default injectIntl(SelectField);